import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { Job } from "@app/models/rest/job";
import { JobRestService } from "@app/services/hal/job-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class JobStore extends RealTimeDataStore<Job> {
  constructor() {
    const jobRestService = inject(JobRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(jobRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Job");
  }
}
